import { Controller } from '@hotwired/stimulus'

// Used as an outlet when we want to have UI elements that are outside of the file-upload controller element
export default class extends Controller {
  static targets = [
    // Will contain the image thumbnail for single-file uploads
    'preview',
    // Clicking this will open the file dialog or remove the uploaded image
    'button',
  ]

  #defaultPreviewHTML
  #defaultButtonHTML

  connect() {
    if (this.hasPreviewTarget)
      this.#defaultPreviewHTML = this.previewTarget.innerHTML
    this.#defaultButtonHTML = this.buttonTarget.innerHTML
  }

  setPreview(imageHtml) {
    this.previewTarget.innerHTML = imageHtml
    this.buttonTarget.innerHTML = 'Remove Image'
  }

  removePreview() {
    this.previewTarget.innerHTML = this.#defaultPreviewHTML
    this.buttonTarget.innerHTML = this.#defaultButtonHTML
  }
}
